<app-modular-form-control-layout [parent]="this">
	<div class="d-flex flex-wrap" [id]="id()">
		<ng-container *ngIf="values$ | async as values">
			<span *ngFor="let value of values" class="badge list-group-item-info cursor-default me-2 mb-1">
				{{value}}
			</span>
		</ng-container>
	</div>
</app-modular-form-control-layout>
